import { withShowIf } from "../../../../../../../../components/with-show-if/with-show-If.component";
import { FlyerDetailPageDetailSideMenu } from "../../features/flyer-detail-page-side-menu/components/flyer-detail-page-detail-side-menu/flyer-detail-page-detail-side-menu.component";
import { FlyerDetailPagePreview } from "../../features/flyer-detail-page-preview/components/flyer-detail-page-preview/flyer-detail-page-preview.component";
import { FlyerDetailPageDrawer } from "../flyer-detail-page-drawer/flyer-detail-page-drawer.component";
import React, { PropsWithChildren, useState } from "react";
import { FlyerDetailPageEditViewProps } from "./flyer-detail-page-edit-view.props";
import { FlyerDetailPageHeader } from "../flyer-detail-page-header/flyer-detail-page-header.component";
import { Content, PageDetailsAndMenu } from "./flyer-detail-page-edit-view.styles";

const DrawerContent = withShowIf((props: PropsWithChildren<any>) => (
  <Content>{props.children}</Content>
));

export const FlyerDetailPageEditView = withShowIf((props: FlyerDetailPageEditViewProps) => {
  const [drawerExpanded, setDrawerExpanded] = useState(false);

  if (!props.pagePreview) {
    return null;
  }

  const onDrawerClose = () => {
    setDrawerExpanded(false);
    props.onDrawerClose();
  };

  return (
    <>
      <DrawerContent showIf={!drawerExpanded}>
        <FlyerDetailPageHeader
          pageLabel={props.pagePreview.label}
          flyerName={props.pagePreview.flyerName}
          onBack={props.onBack}
        />
        <PageDetailsAndMenu>
          <FlyerDetailPagePreview
            flyerEndDatePassed={props.flyerEndDatePassed}
            pagePreview={props.pagePreview}
            editPositionId={props.editPositionId}
            template={props.pageTemplate}
            selectedLanguage={props.selectedLanguage}
            onCreatePagePosition={props.onCreatePagePosition}
            onEditPagePosition={props.onEditPagePosition}
          />
          <FlyerDetailPageDetailSideMenu
            showIf={props.editType === "none"}
            hasPageDetails={props.hasPageDetails}
            editType={props.editType}
            onClick={props.onChangeEditType}
          />
        </PageDetailsAndMenu>
      </DrawerContent>
      <FlyerDetailPageDrawer
        flyerEndDatePassed={props.flyerEndDatePassed}
        pageId={props.pagePreview.pageId}
        pageLabel={props.pagePreview.label}
        showIf={props.editType !== "none"}
        editPositionId={props.editPositionId}
        editType={props.editType}
        permissions={props.permissions}
        selectedLanguage={props.selectedLanguage}
        hasPageDetails={props.hasPageDetails}
        onExpandChange={setDrawerExpanded}
        onPageUpdate={props.onPageUpdate}
        onChangeEditType={props.onChangeEditType}
        onClose={onDrawerClose}
        onSelectLanguage={props.onSelectLanguage}
      />
    </>
  );
});
